// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-23e28d6b] {\n  color: #ed4014;\n}\n.required[data-v-23e28d6b]::before {\n  content: \"*\";\n  color: #ed4014;\n}\n.table-input[data-v-23e28d6b] {\n  width: 200px !important;\n}", ""]);
// Exports
module.exports = exports;
